module.exports = __webpack_public_path__ + "static/media/arrow-right-sm-dark.699dcb6e.svg";